import { render } from "./InputField.vue?vue&type=template&id=42b2a176&ts=true"
import script from "./InputField.vue?vue&type=script&lang=ts"
export * from "./InputField.vue?vue&type=script&lang=ts"

import "./input-field.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__